module.exports = __webpack_public_path__ + "static/media/dmc-white-logo.dad9ef67.png";